import {subCategoryObject} from "@/content/services/1";
import ServiceSubCategoryPage from "@/ui/widgets/service-subcategory-page";

export default function Category1Service5Page() {
    const { category1Service5: subCategory } = subCategoryObject;
    return (<ServiceSubCategoryPage subCategory={subCategory}   />)
}
